import i18n from '@/i18n'
import Pusher from 'pusher-js'
import api from '@/services/api'
import { info } from '@/lib/notification'
import { addApiPrefixAndSuffixOnServerUrl } from '@/lib/api'
import { TokenStorageService as tokenStorage } from '@/services/token'

const { getAccessToken } = tokenStorage

export default {
    state: {
        items: [],
        userId: null,
    },
    mutations: {
        ADD_NOTIFICATION(state, data) {
            state.items.unshift(data)
        },
        SET_NOTIFICATIONS(state, data) {
            state.items = data
        },
        SET_USER_ID(state, id) {
            state.userId = id
        },
    },
    actions: {
        setAllNotificationsAsCompleted({ dispatch, state }) {
            return api
                .put('notifications', {
                    ids: state.items.map((item) => item.id),
                    status: 'completed',
                })
                .then(() => dispatch('getNotifications'))
        },
        getNotifications({ commit, state }) {
            api.get('notifications', {
                params: {
                    search: `receiver_id:${state.userId};status:received,sent,pending;`,
                    searchFields: 'status:in;',
                    and: 'yes',
                    with: 'log_event',
                    orderBy: 'created_at',
                    sortedBy: 'desc',
                },
            }).then((resp) => {
                commit('SET_NOTIFICATIONS', resp.data.data)
            })
        },
        initPusher({ commit, dispatch }, currentUser) {
            if (process.env.NODE_ENV == 'development' && process.env.VUE_APP_SHOW_PUSHER_LOGS) {
                Pusher.logToConsole = true
            }

            const authUrl =
                addApiPrefixAndSuffixOnServerUrl(process.env.VUE_APP_ROOT_URL || window.location.origin) +
                '/notifications/auth'

            const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
                authEndpoint: authUrl,
                cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
                forceTLS: true,
                auth: {
                    headers: {
                        Authorization: `Bearer ${getAccessToken()}`,
                    },
                },
            })

            commit('SET_USER_ID', currentUser.id)
            dispatch('getNotifications')

            let urlPrefix = currentUser.company.url_prefix
            urlPrefix = urlPrefix ? urlPrefix : 'okr'

            const channelName = urlPrefix + '-user-' + currentUser.id
            const channel = pusher.subscribe(channelName)

            const newNotificationToast = () => {
                info(i18n.t('notification.youReceivedANewNotification'))
            }

            channel.bind('goal_suggestion', (payload) => {
                commit('ADD_NOTIFICATION', payload.data)
                newNotificationToast()
            })

            channel.bind('unblock_checkin', (payload) => {
                commit('ADD_NOTIFICATION', payload.data)
                newNotificationToast()
            })

            channel.bind('update_notifications', () => dispatch('getNotifications'))
        },
    },
}
